class LoyaltyOverview extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    document.addEventListener('swell:setup', () => {
      /* eslint-disable-next-line no-undef */
      const customerDetails = swellAPI.getCustomerDetails()
      const customerPointsBalance = customerDetails.pointsBalance
      const pointsNeededForNextTier =
        customerDetails.vipTierStatsNeeded.pointsEarned
      const customerTier = customerDetails.vipTier.name

      if (this.els?.points?.exists) {
        this.els.points.element.textContent = `${customerPointsBalance}`
      }

      if (this.els?.nextPoints?.exists) {
        this.els.nextPoints.element.textContent = `${pointsNeededForNextTier}`
      }

      /* eslint-disable-next-line no-undef */
      const vipTiers = swellAPI.getVipTiers()

      let foundTier = false

      vipTiers.forEach(tier => {
        if (foundTier) {
          if (this.els?.nextTier?.exists) {
            this.els.nextTier.element.textContent = `${tier.name}`
          }

          foundTier = false
        } else if (tier.name === customerTier) {
          foundTier = true
        }
      })

      this.setAttribute('aria-busy', false)
    })
  }
}

if (!customElements.get('loyalty-overview')) {
  customElements.define('loyalty-overview', LoyaltyOverview)
}
